import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { CalendarSelectDrawer } from '@/domain/termine/features/CreateTermin/Drawer/components/CalendarSelectDrawer';
import { CalendarSelectSheet } from '@/domain/termine/features/CreateTermin/Sheet/components/CalendarSelectSheet';

export function CalendarSelectFormField() {
  const { kalender } = useCalendarContext();

  const hasKalender = kalender?.some((k) => k.id !== 'NO_KALENDER');

  if (!hasKalender) {
    return null;
  }

  return (
    <>
      <div className="block md:hidden">
        <CalendarSelectDrawer kalender={kalender} />
      </div>
      <div className="hidden md:block">
        <CalendarSelectSheet kalender={kalender} />
      </div>
    </>
  );
}
